export default function SectionViewAllLink({ label, onClick }) {
  return (
    <div className="projects-view-all">
      <button type="button" className="projects-view-all-link" onClick={onClick}>
        <span>{label}</span>
        <svg
          className="projects-view-all-arrow"
          viewBox="0 0 24 24"
          width="16"
          height="16"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="12 5 19 12 12 19" />
        </svg>
      </button>
    </div>
  );
}
